import React, { useState } from "react";

import { Example, Compare } from "../../example";
import { PhoneNumber } from "./component";

export default function NumberFormatExample() {
  return (
    <Example
      title="Phone number"
      desc={
        <>
          <p>Fade unnecessary characters in phone number.</p>
        </>
      }
      filepath="/src/examples/PhoneNumber/component.js"
      demo={Demo}
    />
  );
}

function Demo() {
  const [value, setValue] = useState("+1-800-123-4567");

  return (
    <Compare>
      <Compare.Group title={<code>{"<input>"}</code>}>
        <label>
          <span className="exampleBlock-label">Phone number</span>
          <input
            className="regularInput"
            value={value}
            onChange={e => {
              setValue(e.target.value);
            }}
          />
        </label>
      </Compare.Group>
      <Compare.Group title={<code>{"<MightyInput>"}</code>}>
        <label>
          <span className="exampleBlock-label">Phone number</span>
          <PhoneNumber value={value} onUpdate={next => setValue(next)} />
        </label>
      </Compare.Group>
    </Compare>
  );
}
